import { isEmpty } from 'ramda'

import { ChartType, Lookup } from '../types'

const getTitleForLookups = (title: string, [{ label, type }, ...rest]: Lookup[]) =>
  `${title}${isEmpty(rest) && type !== ChartType.Search ? ` for ${label}` : ''}`

export default getTitleForLookups
